import { Dispatch } from 'react'
import BudgetGuidance, { BudgetGuidanceType } from '../BudgetGuidance'
import BudgetNotes from '../BudgetNotes'
import { getCurrencySymbol } from '../../../../Utilities/Location/Currency/getCurrencySymbol'
import useBriefContext from '../../../../Hooks/Brief/useBriefContext'
import BudgetCaption from '../BudgetCaption'

interface LFBudgetOptionsInput {
  budget: number | ''
  setBudgetGuidance: Dispatch<BudgetGuidanceType>
  budgetNotes: string
  setBudgetNotes: Dispatch<string>
}

const LFBudgetOptions = ({
  budget,
  setBudgetGuidance,
  budgetNotes,
  setBudgetNotes,
}: LFBudgetOptionsInput): JSX.Element => {
  const { brief } = useBriefContext()
  const currencySymbol = getCurrencySymbol(brief.currency)

  return (
    <>
      <BudgetCaption
        budget={budget || undefined}
        currencySymbol={currencySymbol}
        numGuests={brief.capacities ?? 1}
      />

      <BudgetGuidance brief={brief} setBudgetGuidance={setBudgetGuidance} />
      <BudgetNotes
        value={budgetNotes}
        onBudgetNotesChange={({ target }) => setBudgetNotes(target.value)}
      />
    </>
  )
}

export default LFBudgetOptions
